import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=52d7a80c&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d7a80c')) {
      api.createRecord('52d7a80c', component.options)
    } else {
      api.reload('52d7a80c', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=52d7a80c&", function () {
      api.rerender('52d7a80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G5TlFMCfq87t/JS/ImageCarousel.vue"
export default component.exports